export const IS_OPEN_MODAL_PROFILE = 'IS_OPEN_MODAL_PROFILE';
export const IS_LOADING_SHOW_PROFILE = 'IS_LOADING_SHOW_PROFILE';
export const IS_LOADING_FORM_PROFILE = 'IS_LOADING_FORM_PROFILE';
export const FORM_DATA_PROFILE = 'FORM_DATA_PROFILE';
